import {safeParseJson} from '../../js/tools';

const Transition = {
  FADE: 'fade',
  BLUR: 'blur',
};

export class ItemRotator {
  elements = {
    root: null,
  };
  state = {
    itemIndex: 0,
    nextEventTime: 0,
  };
  data = {
    items: [],
    delay: 0,
    transition: '',
    transitionTime: 1,
  };
  options = {
    renderItem: () => { },
  };

  constructor(element, { renderItem } = options) {
    this.elements = {
      root: element,
    };

    this.data = safeParseJson(this.elements.root.dataset.model);
    this.data.delay = (Number.parseInt(this.data.delay, 10) || 5) * 1000;
    this.data.transition = Transition[this.data.transition?.toUpperCase()] || Transition.FADE;
    this.options.renderItem = renderItem;
    this.run();
  }

  get itemElement() {
    return this.elements.root.querySelector('.item');
  }

  get transitionTime() {
    const time = this.data?.transitionTime || 1;

    return `${time}s`;
  }

  delay(duration = 0) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, duration);
    });
  }

  getNextItemIndex() {
    let nextIndex = this.state.itemIndex + 1;
    if (nextIndex > this.data.items.length - 1) {
      nextIndex = 0;
    }
    return nextIndex;
  }

  renderItem(data) {
    this.elements.root.innerHTML = this.options.renderItem(data);
  }

  async fadeOut() {
    const itemElement = this.itemElement;

    if (!itemElement) {
      return;
    }

    itemElement.style.opacity = 1;
    itemElement.style.transition = `opacity ${this.data.transitionTime}s`;
    itemElement.style.opacity = 0;
    await this.delay(this.data.transitionTime * 1000);
  }

  async fadeIn() {
    const itemElement = this.itemElement;

    if (!itemElement) {
      return;
    }

    itemElement.style.opacity = 0;
    await this.delay(100);
    itemElement.style.transition = `opacity ${this.data.transitionTime}s`;
    itemElement.style.opacity = 1;
    await this.delay(this.data.transitionTime * 1000);
  }

  async blurOut() {
    const itemElement = this.itemElement;

    if (!itemElement) {
      return;
    }

    itemElement.style.filter = 'blur(0px)';
    itemElement.style.opacity = 1;
    itemElement.style.transition = `all ${this.data.transitionTime}s`;
    itemElement.style.filter = 'blur(30px)';
    itemElement.style.opacity = 0;
    await this.delay(this.data.transitionTime * 1000);
  }

  async blurIn() {
    const itemElement = this.itemElement;

    if (!itemElement) {
      return;
    }

    itemElement.style.filter = 'blur(30px)';
    itemElement.style.opacity = 0;
    await this.delay(100);
    itemElement.style.transition = `all ${this.data.transitionTime}s`;
    itemElement.style.filter = 'blur(0px)';
    itemElement.style.opacity = 1;
    await this.delay(this.data.transitionTime * 1000);
  }

  async rotate() {
    this.state.itemIndex = this.getNextItemIndex();
    console.log(`ItemRotator.rotate itemIndex: ${this.state.itemIndex} transition: ${this.data.transition}`);

    let transitionMethodName;

    switch (this.data.transition) {
      case Transition.FADE:
        transitionMethodName = 'fade';
        break;
      case Transition.BLUR:
        transitionMethodName = 'blur';
        break;
    }

    await this[`${transitionMethodName}Out`]?.();

    this.renderItem(this.data.items[this.state.itemIndex]);

    await this[`${transitionMethodName}In`]?.();
  }

  async onAnimationFrame(timeStamp) {
    if (timeStamp >= this.state.nextEventTime) {
      this.state.nextEventTime = timeStamp + this.data.delay;
      console.log(`event triggered: ${timeStamp}, nextEventTime: ${this.state.nextEventTime}`);
      await this.rotate();
    }
    window.requestAnimationFrame(this.onAnimationFrame.bind(this));
  }

  onAnimationFrameEffects() {
    if (this.data.effects?.includes(Effect.ZOOM_IN)) {
      this.applyScaleEffect();
    }
    window.requestAnimationFrame(this.onAnimationFrameEffects.bind(this));
  }

  run() {
    window.requestAnimationFrame(this.onAnimationFrame.bind(this));
  }
}
